//
// State Phase

StatePhase = function() {
	
	var _registeringPhases = false;
	var _exitingState = false;
	var _registeredPhases = [];
	var _activeIndex = -1;
	var _timer = undefined;
	var _timerComplete = false;
	var _timerCompletedCallback = function() {
		_timerComplete = true;
	};
	
	this._currentActiveIndex = -1;
	
	this._registerPhases = function() { 
		_registeredPhases = [];
		_activeIndex = -1;
		this._currentActiveIndex = 0;
		_registeringPhases = true;
		_exitingState = false;
		_timerComplete = false;
	};
	
	this._endRegisterPhases = function() {
		_registeringPhases = false;
		_activeIndex = 0;
		this._currentActiveIndex = 0;
	};
	
	this._exitState = function() {
		_activeIndex = -1;
		_exitingState = true;
	};
	
	this.enter = function() {
		if (_registeringPhases) {
			return true;
		}
		
		return false;
	};
	
	this.timed = function(time) {
		if (_registeringPhases) {
			_registeredPhases.push("TIMED");
		}
		
		if (_exitingState || (_activeIndex !== this._currentActiveIndex++)) {
			return false;
		}
		
		if (_registeredPhases[_activeIndex] == "TIMED") {
			if (_timerComplete) {
				_timerComplete = false;
				_timer = undefined;
				++_activeIndex;
				return true;
			}
			
			if ((_timer !== undefined) && (this.Progress < 1.0)) {
				return true;
			}
			
			_timer = timerManager.addTimer(time, undefined, _timerCompletedCallback);
			return true;
		}
		
		return false;
	};
	
	this.once = function() {
		if (_registeringPhases) {
			_registeredPhases.push("ONCE");
		}
		
		if (_exitingState || (_activeIndex !== this._currentActiveIndex++)) {
			return false;
		}
		
		if (_registeredPhases[_activeIndex] == "ONCE") {
			++_activeIndex;
			return true;
		}
		
		return false;
	};
	
	this.hold = function() {
		if (_registeringPhases) {
			_registeredPhases.push("HOLD");
		}
		
		if (_exitingState || (_activeIndex !== this._currentActiveIndex++)) {
			return false;
		}
		
		if (_registeredPhases[_activeIndex] == "HOLD") {
			return true;
		}
		
		return false;
	};
	
	this.exit = function() {
		if (_registeringPhases) {
			_registeredPhases.push("EXIT");
		}
		
		return _exitingState;
	};
	
	this.step = function() {
		if (_registeredPhases[_activeIndex] == "TIMED") {
			timerManager.stop(_timer);
			_timer = undefined;
			_timerComplete = false;
			++_activeIndex;
		}
		
		if (_registeredPhases[_activeIndex] == "HOLD") {
			++_activeIndex;
		}
	};
	
	this.reset = function() {
		if (_timer !== undefined) {
			timerManager.stop(_timer);
			_timer = undefined;
			_timerComplete = false;
		}
		
		_activeIndex = 0;
	};
	
	Object.defineProperty(this, "Progress", 
	{
		get: function() {
			if (_timer !== undefined) {
				return ((_timer.totalTime - _timer.remainingTime) / _timer.totalTime);
			}
			
			return 1.0;
		}
	});
	
	Object.defineProperty(this, "InverseProgress", 
	{
		get: function() { return (1.0 - this.Progress); }
	});
};